<template>
    <div class="modal" ref="modal">
        <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <button type="button" class="close" style="top: 10px;" @click.prevent="close"><span>×</span></button>
            </div>
            <div class="modal-body">
            <img :src="src" class="enlargeImageModalSource" :alt="$t('common.misc.modelimage')" style="width: 100%;">
            </div>
        </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { mapState } from 'vuex';
import { ImagePreviewState } from '../../store/state_models';



export default defineComponent({
    computed: {
        ...mapState('imagePreview', {
            src: (s: ImagePreviewState) => {
                return s.src;
            },
        })
    },
    watch: {
        'src': function(src: string) {
            const _self = this;
            if (src) {
                $(_self.$refs.modal)
                    .modal('show')
                    .on('hidden.bs.modal', function () {
                        _self.$store.commit('imagePreview/show', '');
                    });;
            } else {
                $(_self.$refs.modal).modal('hide');
            }
        }
    },
    methods: {
        close() {
            const _self = this;
            $(_self.$refs.modal).modal('hide');
        }
    }
});
</script>